(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ht-valintaapu"] && !Shopify.designMode) return;
  try {
    
class HTValintaapu extends HTMLElement {
  connectedCallback() {
    const form = this.querySelector('form');

    if (!form || form.dataset.htValintaapuInitialized) return;
    form.dataset.htValintaapuInitialized = 'true';

    if (window.Shopify?.designMode) return;

    const key = 'ht_valintaapu_pending:' + form.id;
    const success = this.querySelector('[data-ht-form-success="true"]');
    const error = this.querySelector('[data-ht-form-error]');

    if (success) {
      success.focus();

      let pending;

      try {
        pending = JSON.parse(sessionStorage.getItem(key) || 'null');
      } catch (_) {
        return;
      }

      if (
        !pending ||
        typeof pending.id !== 'string' ||
        !Number.isFinite(pending.createdAt) ||
        Date.now() - pending.createdAt < 0 ||
        Date.now() - pending.createdAt > 1800000
      ) {
        return;
      }

      const publish = async (attempt = 0) => {
        if (!this.isConnected) return;

        if (!window.Shopify?.analytics?.publish) {
          if (attempt < 20) {
            setTimeout(() => publish(attempt + 1), 250);
          }
          return;
        }

        try {
          const current = JSON.parse(
            sessionStorage.getItem(key) || 'null'
          );

          if (!current || current.id !== pending.id) return;

          sessionStorage.removeItem(key);

          const result = await window.Shopify.analytics.publish(
            'ht_valintaapu_submitted',
            {
              submission_id: pending.id,
              form_id: form.id
            }
          );

          if (result === false && !sessionStorage.getItem(key)) {
            sessionStorage.setItem(key, JSON.stringify(pending));
          }
        } catch (_) {
        }
      };

      publish();
      return;
    }

    if (error) {
      error.focus();

      try {
        sessionStorage.removeItem(key);
      } catch (_) {}
    }

    const params = new URLSearchParams(window.location.search);

    [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_content',
      'utm_term'
    ].forEach((name) => {
      const value = params.get(name);
      if (!value) return;

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'contact[' + name + ']';
      input.value = value.slice(0, 500);

      form.appendChild(input);
    });

    form.addEventListener('submit', () => {
      try {
        const id = window.crypto?.randomUUID
          ? window.crypto.randomUUID()
          : Date.now().toString(36) +
            '-' +
            Math.random().toString(36).slice(2);

        sessionStorage.setItem(
          key,
          JSON.stringify({
            id: id,
            createdAt: Date.now()
          })
        );
      } catch (_) {}
    });
  }
}

if (!customElements.get('ht-valintaapu')) {
  customElements.define('ht-valintaapu', HTValintaapu);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kangasnayte-form"] && !Shopify.designMode) return;
  try {
    
function initHtFabricSamples(root) {
  if (!root || root.dataset.htFabricInitialized === 'true') return;

  root.dataset.htFabricInitialized = 'true';

  const maxSelected = 7;
  const endpoint = 'https://ht-edge-gate.riku-983.workers.dev';

  const i18n = {
    remainingHint: root.dataset.i18nRemainingHint || 'You can choose {count} more.',
    remainingHintMax: root.dataset.i18nRemainingHintMax || 'Maximum of {max} selected.',
    familyCountAll: root.dataset.i18nFamilyCountAll || '{count} options',
    familyCountFiltered: root.dataset.i18nFamilyCountFiltered || '{visible} / {total}',
    removeSelection: root.dataset.i18nRemoveSelection || 'Remove selection {label}',
  };

  const form = root.querySelector('[data-fabric-form]');
  const checkboxes = Array.from(root.querySelectorAll('[data-fabric-checkbox]'));
  const cards = Array.from(root.querySelectorAll('[data-fabric-card]'));
  const searchInput = root.querySelector('[data-fabric-search]');
  const countEl = root.querySelector('[data-selected-count]');
  const hintEl = root.querySelector('[data-selection-hint]');
  const itemsEl = root.querySelector('[data-selected-items]');
  const emptyEl = root.querySelector('[data-selected-empty]');
  const noResultsEl = root.querySelector('[data-no-results]');
  const resultEl = root.querySelector('[data-form-result]');
  const submitButton = form?.querySelector('.ht-fabric-samples__submit');
  const turnstileContainer = root.querySelector('[data-turnstile-container]');

  let submitting = false;

  const popoverEl = root.querySelector('[data-fabric-popover]');
  const popoverCloseEl = root.querySelector('[data-fabric-popover-close]');
  const popoverImageEl = root.querySelector('[data-fabric-popover-image]');
  const popoverTitleEl = root.querySelector('[data-fabric-popover-title]');
  const popoverSubtitleEl = root.querySelector('[data-fabric-popover-subtitle]');

  function showResult(message) {
    if (!resultEl) return;

    resultEl.textContent = message;
    resultEl.hidden = false;

    resultEl.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    });
  }

  function hideResult() {
    if (resultEl) {
      resultEl.hidden = true;
    }
  }

  function setSubmitState() {
    if (submitButton) {
      submitButton.disabled = submitting;
    }
  }

  function resetTurnstile() {
    if (window.turnstile && turnstileContainer?.id) {
      try {
        window.turnstile.reset('#' + turnstileContainer.id);
      } catch {}
    }
  }

  function normalize(value) {
    return (value || '')
      .toLocaleLowerCase('fi')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function updateFamilyCounts() {
    root.querySelectorAll('[data-family-group]').forEach((group) => {
      const familyCards = Array.from(group.querySelectorAll('[data-fabric-card]'));
      const visibleCards = familyCards.filter((card) => !card.hidden);

      group.hidden = visibleCards.length === 0;

      const familyCount = group.querySelector('[data-family-count]');

      if (!familyCount) return;

      familyCount.textContent =
        visibleCards.length === familyCards.length
          ? i18n.familyCountAll.replace('{count}', familyCards.length)
          : i18n.familyCountFiltered
              .replace('{visible}', visibleCards.length)
              .replace('{total}', familyCards.length);
    });
  }

  function updateSelection() {
    if (!countEl || !hintEl || !itemsEl || !emptyEl) return;

    const selected = checkboxes.filter((checkbox) => checkbox.checked);
    const remaining = maxSelected - selected.length;

    countEl.textContent = selected.length;

    hintEl.textContent =
      remaining > 0
        ? i18n.remainingHint.replace('{count}', remaining)
        : i18n.remainingHintMax.replace('{max}', maxSelected);

    checkboxes.forEach((checkbox) => {
      checkbox.disabled =
        selected.length >= maxSelected && !checkbox.checked;
    });

    itemsEl
      .querySelectorAll('[data-selected-chip]')
      .forEach((chip) => chip.remove());

    emptyEl.hidden = selected.length > 0;

    selected.forEach((checkbox) => {
      const chip = document.createElement('button');

      chip.type = 'button';
      chip.className = 'ht-fabric-samples__chip';
      chip.dataset.selectedChip = checkbox.value;
      chip.textContent = `${checkbox.dataset.label} \u00d7`;

      chip.setAttribute(
        'aria-label',
        i18n.removeSelection.replace('{label}', checkbox.dataset.label)
      );

      chip.addEventListener('click', () => {
        checkbox.checked = false;
        checkbox.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      });

      itemsEl.appendChild(chip);
    });
  }

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      const selected = checkboxes.filter((item) => item.checked);

      if (selected.length > maxSelected) {
        checkbox.checked = false;
      }

      updateSelection();
    });
  });

  if (popoverEl) {
    function openFabricPopover(card) {
      const media = card.querySelector(
        '.ht-fabric-card__image-wrap > *'
      );

      popoverImageEl.replaceChildren();

      if (media) {
        popoverImageEl.appendChild(media.cloneNode(true));
      }

      const title = card.querySelector(
        '.ht-fabric-card__text strong'
      );

      const subtitle = card.querySelector(
        '.ht-fabric-card__text span'
      );

      popoverTitleEl.textContent =
        title ? title.textContent : '';

      popoverSubtitleEl.textContent =
        subtitle ? subtitle.textContent : '';

      popoverSubtitleEl.hidden = !subtitle;

      popoverEl.showModal();
    }

    cards.forEach((card) => {
      if (!card.matches('[data-fabric-popover-trigger]')) return;

      card.addEventListener('click', () => {
        openFabricPopover(card);
      });
    });

    if (popoverCloseEl) {
      popoverCloseEl.addEventListener('click', () => {
        popoverEl.close();
      });
    }

    popoverEl.addEventListener('click', (event) => {
      if (event.target === popoverEl) {
        popoverEl.close();
      }
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', () => {
      const query = normalize(searchInput.value);

      let visibleCount = 0;

      cards.forEach((card) => {
        const matches =
          !query ||
          normalize(card.dataset.search).includes(query);

        card.hidden = !matches;

        if (matches) {
          visibleCount += 1;
        }
      });

      updateFamilyCounts();

      if (noResultsEl) {
        noResultsEl.hidden = visibleCount !== 0;
      }
    });
  }

  if (form) {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (submitting) return;

      hideResult();

      const selected = checkboxes.filter(
        (checkbox) => checkbox.checked
      );

      if (selected.length === 0) {
        showResult('Valitse vähintään yksi kangasnäyte.');

        const firstCard = root.querySelector(
          '[data-fabric-checkbox]'
        );

        if (firstCard) {
          firstCard.focus();
        }

        return;
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const turnstileField =
        form.elements.namedItem('turnstile_token');

      const turnstileToken =
        typeof turnstileField?.value === 'string'
          ? turnstileField.value.trim()
          : '';

      if (!turnstileToken) {
        showResult(
          'Varmennus on vielä kesken. Odota hetki ja yritä uudelleen.'
        );

        return;
      }

      const value = (name) => {
        const field = form.elements.namedItem(name);

        return typeof field?.value === 'string'
          ? field.value.trim()
          : '';
      };

      const payload = {
        first_name: value('first_name'),
        last_name: value('last_name'),
        email: value('email'),
        address: value('address'),
        postal_code: value('postal_code'),
        city: value('city'),
        country: 'Suomi',
        customer_note: value('customer_note'),
        interested_in: '',
        marketing_consent: false,
        samples: selected.map(
          (checkbox) => checkbox.value
        ),
        turnstile_token: turnstileToken,
      };

      submitting = true;

      const originalText =
        submitButton?.textContent ||
        'Tilaa kangasnäytteet';

      if (submitButton) {
        submitButton.textContent = 'Lähetetään...';
      }

      setSubmitState();

      let accepted = false;

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        let body = null;

        try {
          body = await response.json();
        } catch {}

        if (response.status === 429) {
          showResult(
            'Samasta verkosta on tehty useita tilauksia lyhyessä ajassa. Yritä uudelleen noin 30 minuutin kuluttua.'
          );

          resetTurnstile();
          return;
        }

        if (!response.ok) {
          showResult(
            response.status === 403
              ? 'Varmennus epäonnistui. Yritä uudelleen.'
              : 'Tilausta ei voitu lähettää. Yritä hetken kuluttua uudelleen.'
          );

          resetTurnstile();
          return;
        }

        const upstream = body?.data;

        if (
          body?.ok !== true ||
          upstream?.ok !== true ||
          upstream?.accepted !== true
        ) {
          const field = upstream?.field;

          const messages = {
            first_name: 'Tarkista etunimi.',
            last_name: 'Tarkista sukunimi.',
            email: 'Tarkista sähköpostiosoite.',
            address: 'Tarkista katuosoite.',
            postal_code: 'Postinumeron tulee olla viisinumeroinen.',
            city: 'Tarkista postitoimipaikka.',
            customer_note: 'Kerro lyhyesti tarpeestasi.',
            samples: 'Valitse 1–7 kangasnäytettä.',
          };

          showResult(
            messages[field] ||
            'Tarkista lomakkeen tiedot ja yritä uudelleen.'
          );

          resetTurnstile();
          return;
        }

        accepted = true;
                try {
          if (window.Shopify?.analytics?.publish) {
            Promise.resolve(
              window.Shopify.analytics.publish(
                'ht:fabric_sample_request',
                {}
              )
            ).catch(() => {});
          }
        } catch {}
        showResult(
          'Kiitos! Kangasnäytetilauksesi on vastaanotettu.'
        );

        if (submitButton) {
          submitButton.textContent =
            'Tilaus vastaanotettu';
        }

      } catch {
        showResult(
          'Tilausta ei voitu lähettää. Tarkista verkkoyhteys ja yritä uudelleen.'
        );

        resetTurnstile();

      } finally {
        if (!accepted) {
          submitting = false;

          if (submitButton) {
            submitButton.textContent = originalText;
          }

          setSubmitState();
        }
      }
    });
  }

  updateFamilyCounts();
  updateSelection();
  setSubmitState();
}

document
  .querySelectorAll('[data-ht-fabric-samples]')
  .forEach(initHtFabricSamples);

document.addEventListener(
  'shopify:section:load',
  (event) => {
    const root =
      event.target.matches?.('[data-ht-fabric-samples]')
        ? event.target
        : event.target.querySelector?.(
            '[data-ht-fabric-samples]'
          );

    initHtFabricSamples(root);
  }
);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
